import { initTrackViews } from './analytics/trackViews';
import { initTrackClicks } from './analytics/trackClicks';

$(function () {
  setTimeout(() => {
    initTrackViews();
    initTrackClicks();
  }, 1000);
});
